import { useAuth } from '../../../../hooks/useAuth';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';

function ProfileEmailForm() {
  const { user } = useAuth();

  return (
    <Row className="mt-3 mb-2 align-items-center">
      <Col md={2}>
        <Form.Label>Email Address:</Form.Label>
      </Col>
      <Col md={4}>
        <Form.Control
          className="bo-input"
          type="text"
          name="email"
          id="email"
          placeholder="Email address"
          value={user.email}
          disabled
        />
      </Col>
    </Row>
  );
}

export default ProfileEmailForm;
